module.exports = __webpack_public_path__ + "static/about-us-header-ffc5adbca24e064f7212b407a1cdd878.jpg";